import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, SimpleChange, OnChanges, SimpleChanges, AfterContentChecked, ChangeDetectorRef, Directive } from "@angular/core";
import { EnvironmentService } from '../../../services/environment.service';
import { HelperService } from '../../../services/helper/helper.service';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName, ValidatorFn, ValidationErrors, AbstractControlOptions } from '@angular/forms';
import { BaseComponent } from '../base-component/base-component.component';

export type SaleDateValidationResult = { isValid: true } | { isValid: false; errorMessage: string };

@Directive()
export abstract class FormBaseComponent extends BaseComponent implements AfterContentChecked {

  constructor(public helperService: HelperService,
    public environmentService: EnvironmentService,
    public changeDetectionRef: ChangeDetectorRef)
  {
    super(helperService, environmentService);
  }

  requiredIfValidator(predicate) {

    return (formControl => {

      if (!formControl.parent) {
        return null;
      }

      this.helperService.consoleLog('requiredIfValidator predicate ' + predicate());

      if (predicate()) {

        return Validators.required(formControl);
      } else {

        return null;
      }
    });
  }


  requiredBindValidator(model: any, bindValue: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

      if (!model) {
        return null;
      }

      if (model[bindValue]) {
        return null;
      } else {
        return { 'requirder': true };
       }
    };
  }

  telephoneIfValidator(predicate): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      let isTelephoneValid: boolean = false;

      const value: string  = control.value;

      if (!value) {
        return null;
      }

      if (predicate()) {

        let telephone = value.replace(/\D/g, '');

        let isMatch = telephone.match('^\\d{9}$');

        return !isMatch ? { telephoneValid: true } : null;
      }
      else {
        return null;
      }
    };
  }

  telephoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      let isTelephoneValid: boolean = false;

      const value: string = control.value;

      if (!value) {
        return null;
      }

      let telephone = value.replace(/\D/g, '');

      let isMatch = telephone.match('^\\d{9}$');


      return !isMatch ? { telephoneValid: true } : null;
    };
  }

  postalCodeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      let isTelephoneValid: boolean = false;

      const value: string = control.value;

      if (!value) {
        return null;
      }

      let postalCode = value.replace(/\D/g, '');

      let isMatch = postalCode.match('^\\d{5}$');

      return !isMatch ? { telephoneValid: true } : null;
    };
  }

  nipValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      let isTelephoneValid: boolean = false;

      const value: string = control.value;

      if (!value) {
        return null;
      }

      let postalCode = value.replace(/\D/g, '');

      let isMatch = postalCode.match('^\\d{10}$');

      return !isMatch ? { telephoneValid: true } : null;
    };
  }

  isValidSaleDate(saleDate: Date): SaleDateValidationResult {
    // Normalize to date-only (ignore time)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const sale = new Date(saleDate);
    sale.setHours(0, 0, 0, 0);

    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const prevMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const nextMonthStart = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    const fmt = (d: Date) => {
      // YYYY-MM-DD in local time
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    // Reject anything older than previous month immediately
    if (sale < prevMonthStart) {
      return {
        isValid: false,
        errorMessage: `Data sprzedaży nie może być wcześniejsza niż ${fmt(prevMonthStart)}.`,
      };
    }

    // Rule 3: current month -> any date in current month is valid
    if (sale >= currentMonthStart && sale < nextMonthStart) {
      return { isValid: true };
    }

    // Rule 1: previous month allowed only if today is on/before 15th of current month
    if (sale >= prevMonthStart && sale < currentMonthStart) {
      if (today.getDate() <= 15) return { isValid: true };

      return {
        isValid: false,
        errorMessage: `Data sprzedaży z poprzedniego miesiąca jest dozwolona tylko do 15. dnia bieżącego miesiąca (dziś: ${fmt(
          today
        )}).`,
      };
    }

    // Rule 2: future allowed only up to 60 days ahead (inclusive)
    if (sale > today) {
      const maxFuture = new Date(today);
      maxFuture.setDate(maxFuture.getDate() + 60);

      if (sale <= maxFuture) return { isValid: true };

      return {
        isValid: false,
        errorMessage: `Data sprzedaży w przyszłości nie może być późniejsza niż ${fmt(
          maxFuture
        )} (60 dni od dziś).`,
      };
    }

    // Safety net
    return { isValid: false, errorMessage: "Nieprawidłowa data sprzedaży." };
  }

  ngAfterContentChecked() {
    if (this.changeDetectionRef) {
      this.changeDetectionRef.detectChanges();
    }
  }
}

